module.exports = __webpack_public_path__ + "img/296.e37f91c0.jpg";